export const LanguagesEnum = {
    ENGLISH: 'gb',
    DANISH: 'dk',
    NORWEGIAN: 'no',
}
